export default __webpack_public_path__ + "static/media/title_logo_rounded.a54b5e89.svg";